import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ProductCardBadges extends ThemeComponent {

}
